module.exports = __webpack_public_path__ + "img/example8-2.99d07300.png";